import { Card, Grid, Typography } from "@mui/material";
import styles from "../Information.module.scss";
import GridTableComponent from "../../common/GridTableComponent/gridTableTemplate";
import { useEffect } from "react";

const IndividualSamskars = () => {
  const ItemAddedData = [
    {
      ItemsNames: "Rice",
      Quantity: "5 Lb",
    },
    {
      ItemsNames: "Akshata(Yellow Rice)",
      Quantity: "1/2 Lb",
    },
    {
      ItemsNames: "Haldi",
      Quantity: "25 grams",
    },
    {
      ItemsNames: "kumkum",
      Quantity: "25 grams",
    },
    {
      ItemsNames: "camphor",
      Quantity: "1 packet",
    },
    {
      ItemsNames: "milk",
      Quantity: "ï¿½ Gallon",
    },
    {
      ItemsNames: "coconuts",
      Quantity: "5",
    },
    {
      ItemsNames: "Raisin",
      Quantity: "1 lb",
    },
    {
      ItemsNames: "Loose Flowers",
      Quantity: "some",
    },
    {
      ItemsNames: "Loose Flowers",
      Quantity: "some",
    },
    {
      ItemsNames: "Mangalya (gold chainOr Yellow thread)",
      Quantity: "1",
    },
    {
      ItemsNames: "Chain of black beeds",
      Quantity: "1",
    },
    {
      ItemsNames: "Firewood (preferably Kinding wood)",
      Quantity: "",
    },
  ];
  const ItemAddedDataVivaham = [
    {
      ItemsNames: "Betel Leaves",
      Quantity: "30",
    },
    {
      ItemsNames: "Betel Nut powder",
      Quantity: "10 pkts",
    },
    {
      ItemsNames: "Fruits",
      Quantity: "25",
    },
    {
      ItemsNames: "Puffed rice",
      Quantity: "100 grms",
    },
    {
      ItemsNames: "Agarbathi",
      Quantity: "1 packet",
    },
    {
      ItemsNames: "Honey",
      Quantity: "1 bottel",
    },
    {
      ItemsNames: "Cashews",
      Quantity: "1 lb",
    },
    {
      ItemsNames: "Almonds 1 Lb",
      Quantity: "1 lb",
    },
    {
      ItemsNames: "Silver Toe rings",
      Quantity: "2 pairs",
    },
    {
      ItemsNames: "Madhuparka (Dress for the Groom)",
      Quantity: "1",
    },
    {
      ItemsNames: "Mangalya (gold chainOr Yellow thread)",
      Quantity: "1",
    },
    {
      ItemsNames: "Ball of cumin seeds mixed with Indian jaggery",
      Quantity: "one small ball",
    },
    {
      ItemsNames: "Ghee",
      Quantity: "3 Lb",
    },
  ];
  const ItemAddedSeemanths = [
    {
      ItemsNames: "Rice",
      Quantity: "5 Lbs",
    },
    {
      ItemsNames: "Coconuts",
      Quantity: "2",
    },
    {
      ItemsNames: "Loose Flowers",
      Quantity: "Some",
    },
    {
      ItemsNames: "Agarabathi",
      Quantity: "1 pkt",
    },
    {
      ItemsNames: "Milk (for namakarana)",
      Quantity: "1 ½ Gallon",
    },
  ];
  const ItemAddedSeemanthsData = [
    {
      ItemsNames: "Betel Leaves",
      Quantity: "15",
    },
    {
      ItemsNames: "Betel nut powder",
      Quantity: "10 pkts",
    },
    {
      ItemsNames: "Camphor",
      Quantity: "1 pkt",
    },
    {
      ItemsNames: "Cooked prasadam",
      Quantity: "some",
    },
    {
      ItemsNames: "Diluted milk (for Annapayasa)",
      Quantity: "1 Cup",
    },
  ];
  const ItemAddedUpanyaya = [
    {
      ItemsNames: "Rice (uncooked)",
      Quantity: "5 Lbs",
    },
    {
      ItemsNames: "Akshatha (Yellow rice)",
      Quantity: "1 Cup",
    },
    {
      ItemsNames: "Haldi",
      Quantity: "25 Grams",
    },
    {
      ItemsNames: "Kumkum",
      Quantity: "25 grams",
    },
    {
      ItemsNames: "Camphor",
      Quantity: "1 pkt",
    },
    {
      ItemsNames: "Milk",
      Quantity: "1 ½ Gallon",
    },
    {
      ItemsNames: "coconuts",
      Quantity: "5",
    },
    {
      ItemsNames: "Ghee",
      Quantity: "3 Lb",
    },
    {
      ItemsNames: "Murukku & appam",
      Quantity: "10 each",
    },
    {
      ItemsNames: "Cooked rice (for havan)",
      Quantity: "1 Cup",
    },
    {
      ItemsNames: "Raisins",
      Quantity: "1 ½ lb",
    },
    {
      ItemsNames: "Dhotees with angavastharas",
      Quantity: "2",
    },
    {
      ItemsNames: "Agarabathi",
      Quantity: "1 pkt",
    },
    {
      ItemsNames: "Rice with any ingredients for Kumara Bhojan",
      Quantity: "some",
    },
  ];
  const ItemAddedUpanyayaData = [
    {
      ItemsNames: "Betel Leaves",
      Quantity: "30",
    },
    {
      ItemsNames: "Betel Nut powder",
      Quantity: "10 pkts",
    },
    {
      ItemsNames: "fruits",
      Quantity: "25",
    },
    {
      ItemsNames: "puffed Rice",
      Quantity: "100 grams",
    },
    {
      ItemsNames: "Agarabathi",
      Quantity: "1 pkt",
    },
    {
      ItemsNames: "Honey",
      Quantity: "1 bottel",
    },
    {
      ItemsNames: "Cashews",
      Quantity: "1 ½ lb",
    },
    {
      ItemsNames: "Loose flowers",
      Quantity: "some",
    },
    {
      ItemsNames: "Appam",
      Quantity: "10",
    },
    {
      ItemsNames: "Almonds",
      Quantity: "1 ½ lb",
    },
    {
      ItemsNames: "Camphor",
      Quantity: "1 pkt",
    },
    {
      ItemsNames: "Panchapathram with spoon",
      Quantity: "1",
    },
    {
      ItemsNames: "Chandan Tablets",
      Quantity: "10",
    },
    {
      ItemsNames: "Firewood (preferably Kindling wood)",
      Quantity: "some",
    },
    
    {
      ItemsNames: "Blouse pieces",
      Quantity: "3",
    },
  ];
  const columnMapping = {
    ItemsNames: "Item Names",
    Quantity: "Quantity",
  };

  const AnnuualAbhisekaItems = [
    {
      ItemsNames: "Betel Leaves",
      Quantity: "30 ",
    },
    {
      ItemsNames: "Betal Nut Powder",
      Quantity: "10 Packets",
    },
    {
      ItemsNames: "Fruits",
      Quantity: "25",
    },
    {
      ItemsNames: "Puffed Rice",
      Quantity: "100 grams",
    },
    {
      ItemsNames: "Agarbhathi",
      Quantity: "1 Packet ",
    },
    {
      ItemsNames: "Honey",
      Quantity: "1 Bottle",
    },
    {
      ItemsNames: "Cashews",
      Quantity: "1 Lb",
    },
    {
      ItemsNames: "Almonds",
      Quantity: "1 Lb",
    },
    {
      ItemsNames: "Silver Toe rings",
      Quantity: "2 pairs ",
    },
    {
      ItemsNames: "Madhuparka(Dress for the Groom)",
      Quantity: "1",
    },
    {
      ItemsNames: "Ball of Cumin seeds mixed with Indian jaggery",
      Quantity: "One small ball",
    },
    {
      ItemsNames: "Ghee",
      Quantity: "3 Lb",
    },
    
  ];
  const AnnuualAbhisekaItemsAndServiceProgram = [
    {
      ItemsNames: "Rice",
      Quantity: "5 Lb",
    },
    {
      ItemsNames: "Akshatha(Yellow Rice)",
      Quantity: "1½ Lb",
    },
    {
      ItemsNames: "Haldi",
      Quantity: "25 grams",
    },
    {
      ItemsNames: "Kumkum",
      Quantity: "25 grams",
    },
    {
      ItemsNames: "Camphor",
      Quantity: "1 Packet",
    },
    {
      ItemsNames: "Milk",
      Quantity: "1½ Gallon ",
    },
    {
      ItemsNames: "Coconuts",
      Quantity: "5",
    },
    {
      ItemsNames: "Raisin",
      Quantity: "1 Lb",
    },
    {
      ItemsNames: "Loose Flowers",
      Quantity: "Some",
    },
    {
      ItemsNames: "Mangalya(Gold Chain) or Yellow Thread",
      Quantity: "1",
    },
    {
      ItemsNames: "Chain of Black Seeds",
      Quantity: "1",
    },
    {
      ItemsNames: "Firewood (Preferably Kinding Wood)",
      Quantity: "",
    },
   
  ];

  const AnuualAbhisekhamTable = () => {
    return (
      <>
        {AnnuualAbhisekaItems.length > 0 ? (
          <div>
            <table className={styles.tableContainer}>
              <tbody className={styles.tableBody}>
                {AnnuualAbhisekaItems.map((row) => (
                  <tr key={row.ItemsNames} className={styles.tableRow}>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        textAlign: "left",
                      }}
                    >
                      {row.Quantity}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          ""
        )}
      </>
    );
  };
  const AnuualAbhisekhamTableAndServicesTable = () => {
    return (
      <>
        {AnnuualAbhisekaItemsAndServiceProgram.length > 0 ? (
          <div>
            <table className={styles.tableContainer}>
              <tbody className={styles.tableBody}>
                {AnnuualAbhisekaItemsAndServiceProgram.map((row) => (
                  <tr key={row.ItemsNames} className={styles.tableRow}>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        textAlign: "left",
                      }}
                    >
                      {row.ItemsNames}
                    </td>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        fontWeight: 400,
                        color: "#000",
                        textAlign: "left",
                      }}
                    >
                      {row.Quantity}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          ""
        )}
      </>
    );
  };
  return (
    <>
      <div>
        <div className={styles.IndividualsamskarLayout}>
          <Card className={styles.cardContainer}>
            <Grid>
              <Typography className={styles.content}>
                The objective of the Samskaras, are several. The removal of evil
                spirits, invoking blessings from Gods for material gains,
                longevity and good progeny, are a few of these. Different
                Mantras are chanted and different gods are worshipped depending
                upon the ceremony.
              </Typography>
            </Grid>
            <Grid container spacing={2}>
              <Grid xs={12} sm={3} item>
                <Typography className={styles.Header}>Vivaham</Typography>
                <Grid>
                  <Typography className={styles.secondcontent}>
                    All the traditions and Sampradayas agreed that marriage is a
                    divine samskara to get along Dharma, Artha, Kama and Moksha.
                    The Temple helps in conducting marriages. For the Muhurtha
                    (auspicious time), one can get the help of the priest. You
                    are required to bring these items for conducting a marriage.
                    In fact, you can request the Temple to conduct the wedding
                    in the Temple Assembly Hall or out side.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <div style={{ marginTop: "10px" }}>
              <Grid xs={12} sm={3}>
                <div className={styles.tableContainer}>
                  <div className={styles.tableWrapper}>
                    <GridTableComponent
                      tableData={ItemAddedData}
                      columnMapping={columnMapping}
                    />
                  </div>
                  <div className={styles.tableWrapper}>
                    <GridTableComponent
                      tableData={ItemAddedDataVivaham}
                      columnMapping={columnMapping}
                    />
                  </div>
                </div>
                <div className={styles.tableContainer}>
                  <Typography className={styles.secondcontent}>
                    Two flower garlands will be supplied on request and payment.
                    Advance request is required. You can ask the priest for any
                    special items you may need
                    <br /> to conduct the wedding as per your sampradaya. Please
                    confirm this list with the priest.
                  </Typography>
                </div>
              </Grid>
            </div>
            <Grid container spacing={2}>
              <Grid xs={12} sm={3} item>
                <Typography className={styles.Header}>Seemantham</Typography>
                <Grid>
                  <Typography className={styles.secondcontent}>
                    Performed in the 7th or 8th month of pregnancy. You can
                    consult the priest for the auspicious time and the items
                    needed. Veda parayana, Santhi pata pravachana also can be
                    arranged at home or in the Temple. Please contact manager if
                    you need more information.
                  </Typography>
                  <br />
                </Grid>
                <Grid>
                  <Typography className={styles.secondcontent}>
                    All the other birth related Samskaras like, Pumsavana
                    (Performed in the 2nd, 3rd, 4th month), Jaatakarma
                    (immediately after child birth), Nama Karana (child naming
                    cermony 10th or 12th day after birth), Punyaha Vachana, Anna
                    prasana (First feeding of cooked rice to child, at 6th
                    month), Mundana, Akshara-abhyasa make the child eligible for
                    the next samskara and purify the body to recive the
                    spiritual vibrations very quickly.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <div>
              <div className={styles.tableContainer}>
                <div className={styles.tableWrapper}>
                  <GridTableComponent
                    tableData={ItemAddedSeemanths}
                    columnMapping={columnMapping}
                  />
                </div>
                <div className={styles.tableWrapper}>
                  <GridTableComponent
                    tableData={ItemAddedSeemanthsData}
                    columnMapping={columnMapping}
                  />
                </div>
              </div>
              <br />
              <div className={styles.tableContainer}>
                <Grid>
                  <Typography className={styles.secondcontent}>
                    Extra milk for Annaprasana. One white hand-kerchief and new
                    scissors, extra for Mundan. One slate
                    <br /> for writing material, extra for Akshar-abhayasa.
                  </Typography>
                </Grid>
              </div>
            </div>
            <Grid container spacing={2} sx={{ marginTop: "25px" }}>
              <Grid item xs={12}>
                <Typography className={styles.upanyayaHeader}>
                  Upanayana (Thread Ceremony)
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography className={styles.secondcontent}>
                  A sacred thread is prescribed for the three classes like
                  Brahmana, Kshatriya and Vaisya in their respective traditions
                  and they are advised to consult the priest for their
                  sampradaya. In order to get the eligibility to the Nitya
                  Karma, Veda adhyana and Yajna - Yaga sacrifices, one needs to
                  get the samskara. To set the auspicious Muhurtha you can get
                  help from any priest.
                </Typography>
              </Grid>
            </Grid>
            <Grid xs={12} sm={3}>
              <div className={styles.tableContainer}>
                <div className={styles.tableWrapper}>
                  <GridTableComponent
                    tableData={ItemAddedUpanyaya}
                    columnMapping={columnMapping}
                  />
                </div>
                <div className={styles.tableWrapper}>
                  <GridTableComponent
                    tableData={ItemAddedUpanyayaData}
                    columnMapping={columnMapping}
                  />
                </div>
              </div>
            </Grid>
            <br />
            <div className={styles.tableContainer}>
              <Typography className={styles.secondcontent}>
                You can ask priest for any special items you wish to include in
                the Upanayana as per your Sampradaya.
              </Typography>
            </div>
            <Grid container spacing={2} sx={{ marginTop: "25px" }}>
              <Grid item xs={12}>
                <Typography className={styles.upanyayaHeader}>
                  Ayushya Homa
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography className={styles.secondcontent}>
                  Normally when a child completes his/her first year, the
                  Ayushya Homa is recommended by the Rishis for the long life of
                  the baby.
                </Typography>
                <Typography className={styles.secondcontent}>
                  <b>
                    In addition to the above items for the samskaras, these
                    following items are needed.
                  </b>
                </Typography>
                <Typography className={styles.secondcontent}>
                  New clothes for the baby, ghee (2 lbs), firewood - preferably
                  kindling wood (1 pkt), cooked rice (1 cup), dry fruits -
                  cashews, almonds, raisin (1/2 lbs each), home cooked prasada
                  like sharkar pongal.
                </Typography>
                <Typography className={styles.secondcontent}>
                  If you do the same in a grand scale for the 60th Birthday
                  (Shashtiyabhipurthi) Shanthi, Sahasra Chandra Darsha Shanthi
                  at the age of 80, some more items may be needed. Please
                  contact the Manager for more details.
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: "25px" }}>
              <Grid item xs={12}>
                <Typography className={styles.upanyayaHeader}>
                  Satyanarayana Puja
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography className={styles.secondcontent}>
                  Conducted every Saturday and Sunday from 3:00 pm to 4:30 pm in
                  the Temple. This is the most common worship for the general
                  well being and for individual benefits. Performing this puja
                  on a full moon day is very auspicious. One can perform this
                  worship at home or within Temple, collectively or
                  individually.
                </Typography>{" "}
                <br />
                <div className={styles.tableContainer}>
                <div className={styles.tableWrapper}>
                  <GridTableComponent
                    tableData={AnnuualAbhisekaItemsAndServiceProgram}
                    columnMapping={columnMapping}
                  />
                </div>
                <div className={styles.tableWrapper}>
                  <GridTableComponent
                    tableData={AnnuualAbhisekaItems}
                    columnMapping={columnMapping}
                  />
                </div>
                </div>
                <br />
                <Typography className={styles.secondcontent}>
                  Panchamrutha in a cup (milk, honey, butter, sugar, ghee and
                  banana slices and slices of 4 other fruits). A picture of
                  Satyanarayana Swamy. Satyanarayana Story. Satyanarayana Prasad
                  either dry or in kesari form. Small packets of Navadhanyas -
                  Whole Wheat (Sun), whole white Rice (Moon), Whole Toordhal
                  (Angaraka), Whole Moongdhal (Budha), Whole Channadhal
                  (Brahaspathi), Black eye peas (Shukra), Black Sesame (Shani),
                  Black Whole Urad dhal (Raghu), Horse gram or small lentils
                  (Kethu).
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: "25px" }}>
              <Grid item xs={12}>
                <Typography className={styles.upanyayaHeader}>
                  Vahana (Car / Truck) Puja
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography className={styles.secondcontent}>
                  Bring 4 lemons, 1 coconut, flowers, fruits, karpoor or camphor
                  (one small pkt).
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: "25px" }}>
              <Grid item xs={12}>
                <Typography className={styles.upanyayaHeader}>
                  Bhoomi Puja
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography className={styles.secondcontent}>
                  While construction is going to take place the puja is
                  recommended in the sastras as Bhoomi worship.
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: "25px" }}>
              <Grid item xs={12}>
                <Typography className={styles.upanyayaHeader}>
                  Grihapravesam
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography className={styles.secondcontent}>
                  While entering into a new or already dwelling home to please
                  the presiding deity of the place. A vastu puja is recommended.
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} >
              <Grid item xs={12}>
                <Typography className={styles.upanyayaHeader}>
                  Shraaddha (Service to departed souls)
                </Typography>
              </Grid>
              
              <Grid item xs={12}>
                <Typography className={styles.secondcontent} sx={{marginTop:"16px"}}>
                  Paying respects to the departed souls is considered as the
                  most sacred ceremony in the Vedic tradition. The Temple
                  assists in performing this at Temple or at devotee's home.
                </Typography>
                <Typography className={styles.secondcontent}>
                  <b>Items Needed:</b>
                </Typography>
                <Typography className={styles.secondcontent}>
                  Rice, vegetables (uncooked) Indian jaggery, milk, yogurt,
                  sesame seeds, Toordhal, one coconut and fruits. Devotees can
                  contact the manager for more details with regard to the Death
                  Rites, Maasikas, Anna Shraaddhas with Homas.
                </Typography>
                <br />
                <Typography className={styles.secondcontent}>Note:</Typography>
                <Typography>
                  <b>Anna Shraddhas</b> or <b>Pinda Pradana</b> can be performed
                  only outside the Temple premises. Please contact manager for
                  more details.
                </Typography>
                <br />
                <Typography>
                  <b>
                    For Ganapathi Homa, Mrutyunjaya Homa, Rudra Homa, Trisati
                    Homa, Pancha Sukta Homa, Sudarshana Homa, Chandi Homa, Shree
                    Sukta Homa, Durga Sukta Homa, Lalitha Sahasranama Homa,
                    Lakshmi Homa, Navagraha Homa, etc.
                  </b>
                </Typography>
                <Typography className={styles.secondcontent}>
                  A homa, or fire offering, is a sacred ceremony in which the
                  Gods are offered oblations through the medium of fire
                  according to Vedic scriptual injuctions while special mantras
                  are recited. A Homa is performed during specific auspicious
                  occasions for the benefit of the entire world as well as the
                  participants.
                </Typography>
                <br />
                <Typography className={styles.secondcontent}>
                  One must understand that the actions of the Homa are a
                  nourishment for the Devatas, who all correspond to basic
                  principals of nature. By nourishing those energies one gets
                  the support of nature. All objects which are offered into Agni
                  refer to specific deities. These deities who are governing
                  different main aspects of Nature, bless us with overall health
                  and well being.
                </Typography>
                <br />
                <Typography className={styles.secondcontent}>
                  You can consult the concerned priest for the items to be
                  brought for the particular homa of your choice. Contact
                  Manager for more details.
                </Typography>
                <Typography>
                  <b>Please Note:</b>
                </Typography>
                <Typography className={styles.secondcontent}>
                  dentification of a specific solution requires in-depth
                  knowledge of the subject and the systems. Seeking advice from
                  knowledgeable and experienced vedic scholars is very crucial.
                  Performing Puja/Homa/Japa with all devotion to God and not as
                  a ritual is the key to utmost satisfaction.
                </Typography>
              </Grid>
            </Grid>
          </Card>
        </div>
      </div>
    </>
  );
};
export default IndividualSamskars;
